import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterValues: {
    brachArrayWithCode: [],
    branch: [],
    //branch data getting from tabel and above variable to resend the same data back
    branchValueFromResponse: "",
    branchValue: null,
    branchCode: "",
    paymentTypeWithDesArray: [],
    paymentTypeArray: [],
    paymentType: "",
    voucherDate: null,
    VoucherNumberArray: [],
    voucherNumberValue: "",
    fundTransferMode: "",
    paymentBankOrCash: "",
    //This method used to compare the final array of object with the initial state
    initialResponseRowValue: [],
  },
  newRow: {
    filePaymentHeaderKey: "",
    voucherType: "",
    approvalFlg: "",
  },
  HideComponents: {
    showGridComponent: false,
  },
  filterValueTouched: {
    branchTouch: false,
    voucherNumberTouch: false,
  },
  filterValueIsValid: {
    branchIsValid: false,
    voucherNumberIsValid: false,
  },
  gridValues: {
    rows: [],
    applicationNumberArray: [],
    GLValAndDesArray: [],
    allBranchGlAccounts: {},
    GLAccountArray: [],
  },
  modalValue: {
    customerName: "",
    bankName: "",
    bankBranchName: "",
    ifsc: "",
    bankAccNum: "",
    accountType: "",
    emiStartDate: "",
    emiAmt: "",
  },

  CustomerBankDetails: {
    customerName: "",
    bankName: "",
    bankBranchName: "",
    accountType: "",
    ifsc: "",
    bankAccNum: "",
  },
  customerEmiData: {
    emiStartDate: "",
    emiAmt: "",
  },
  //Validation
  validation: {
    Gldes: [],
    errorApplicationNumber: [],
  },
  modes: {
    screenMode: "",
    initialRows: "",
  },
  remarks: {
    deleteRemarks: "",
    remarksTouchHandler: false,
  },
};
const FilePaymentModifyReducer = createSlice({
  name: "modify",
  initialState: initialState,
  reducers: {
    updateBrachArrayWithCode(state, action) {
      state.filterValues.brachArrayWithCode = action.payload;
    },
    updateBranchArray(state, action) {
      state.filterValues.branch = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterValues.branchValue = action.payload;
      state.filterValueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateBranchIsTouched(state, action) {
      state.filterValueTouched.branchTouch = action.payload;
    },
    updateInitialResponseRowValue(state, action) {
      state.filterValues.initialResponseRowValue = action.payload;
    },

    updatePaymentTypeWithDesArray(state, action) {
      state.filterValues.paymentTypeWithDesArray = action.payload;
    },
    updatePaymentTypeArray(state, action) {
      state.filterValues.paymentTypeArray = action.payload;
    },
    //MAthod to update FilterValues
    updateFilterValues(state, action) {
      state.filterValues.paymentType = action.payload.paymentType;

      state.filterValues.fundTransferMode = action.payload.fundTransferMode;
      state.filterValues.voucherDate = action.payload.voucherDate;

      state.newRow.filePaymentHeaderKey = action.payload.filePaymentHeaderKey;
      state.newRow.approvalFlg = action.payload.approvalFlg;
      state.filterValues.paymentBankOrCash = action.payload.paymentBankOrCash;
      state.filterValues.paymentCode = action.payload.paymentCode;
      state.filterValues.branchCode = action.payload.branchCode;
      state.filterValues.branchValueFromResponse = action.payload.branch;
    },

    updatePaymentCode(state, action) {
      state.filterValues.paymentCode = action.payload;
    },
    updateVoucherNumberArray(state, action) {
      state.filterValues.VoucherNumberArray = action.payload;
    },
    updateVoucherNumberValue(state, action) {
      state.filterValues.voucherNumberValue = action.payload;
      state.filterValueIsValid.voucherNumberIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateVoucherNumberIsTouched(state, action) {
      state.filterValueTouched.voucherNumberTouch = action.payload;
    },

    //Reducer for show and hide components
    updateShowGridCompponent(state, action) {
      state.HideComponents.showGridComponent = action.payload;
    },
    //Grid value changes
    updateRows(state, action) {
      state.gridValues.rows = action.payload;
    },
    addRows(state, action) {
      state.gridValues.rows = [...state.gridValues.rows, action.payload];
    },
    updateGLValAndDesArray(state, action) {
      state.gridValues.GLValAndDesArray = action.payload;
    },
    updateAllBranchGlAccounts(state, action) {
      state.gridValues.allBranchGlAccounts = action.payload;
    },
    updateGLAccountArray(state, action) {
      state.gridValues.GLAccountArray = action.payload;
    },
    //Reducers for updating modal value
    updateModalValue(state, action) {
      state.modalValue.customerName = action.payload.customerName;
      state.modalValue.bankName = action.payload.bankName;
      state.modalValue.bankBranchName = action.payload.bankBranchName;
      state.modalValue.ifsc = action.payload.ifsc;
      state.modalValue.bankAccNum = action.payload.bankAccNum;
      state.modalValue.accountType = action.payload.accountType;
      state.modalValue.emiStartDate = action.payload.emiStartDate;
      state.modalValue.emiAmt = action.payload.emiAmt;
    },

    //Validation Reducers
    updateValidationGlDes(state, action) {
      state.validation.Gldes = action.payload;
    },
    updateErrorApplicationDetails(state, action) {
      state.validation.errorApplicationNumber = action.payload;
    },
    branchOnChangeResetHandler(state, action) {
      state.filterValues.paymentType = "";
      state.filterValues.voucherDate = null;
      state.filterValues.voucherNumberValue = "";
      state.filterValues.VoucherNumberArray = [];
      state.gridValues.rows = [];
      state.filterValueIsValid.voucherNumberIsValid = false;
      state.filterValueTouched.branchTouch = false;
      state.HideComponents.showGridComponent = false;
      state.filterValues.paymentBankOrCash = "";
    },
    voucherNumberOnChangeResetHandler(state, action) {
      state.HideComponents.showGridComponent = false;
      state.filterValues.paymentType = "";
      state.filterValues.paymentBankOrCash = "";
      state.filterValues.voucherDate = null;
      state.filterValues.fundTransferMode = "";
    },
    resetValues(state, action) {
      state.filterValues.branchValue = "";
      state.filterValues.applicationNumberArray = [];
      state.filterValues.applicationNumberValue = "";
      state.filterValues.paymentTypeWithDesArray = [];
      state.filterValues.paymentTypeArray = [];
      state.filterValues.paymentType = "";
      state.filterValues.paymentBankOrCash = "";
      state.filterValues.voucherDate = null;
      state.filterValues.VoucherNumberArray = [];
      state.filterValues.voucherNumberValue = "";
      state.gridValues.rows = [];
      state.HideComponents.showGridComponent = false;
      state.filterValueTouched.branchTouch = false;
      state.filterValueTouched.voucherNumberTouch = false;
      state.filterValueIsValid.branchIsValid = false;
      state.filterValueIsValid.voucherNumberIsValid = false;
    },

    //Reducer for updating Bank details
    //Used while add row button clicked
    updateBankDetails(state, action) {
      state.CustomerBankDetails.customerName = action.payload.accHoldrName;
      state.CustomerBankDetails.bankName = action.payload.bankName;
      state.CustomerBankDetails.bankBranchName = action.payload.bankBranchName;
      state.CustomerBankDetails.accountType = action.payload.bankAccountType;
      state.CustomerBankDetails.ifsc = action.payload.ifscCode;
      state.CustomerBankDetails.bankAccNum = action.payload.bankAccountNum;
    },
    updateEmiStatus(state, action) {
      state.customerEmiData.emiStartDate = action.payload.emiStartDate
        ? action.payload.emiStartDate
        : null;
      state.customerEmiData.emiAmt = action.payload.emiAmt
        ? action.payload.emiAmt
        : "";
    },
    //Grid value change handler
    updateApplicationArray(state, action) {
      state.gridValues.applicationNumberArray = action.payload;
    },
    updateScreenModes(state, action) {
      state.modes.screenMode = action.payload;
    },
    updateRemarks(state, action) {
      state.remarks.deleteRemarks = action.payload;
    },
    updateRemarksTouchHandler(state, action) {
      state.remarks.remarksTouchHandler = action.payload;
    },
  },
});
export const FilePaymentModifyReducerAction = FilePaymentModifyReducer.actions;
export default FilePaymentModifyReducer.reducer;
